import { render, staticRenderFns } from "./SupplierAdInfo.vue?vue&type=template&id=019d0ca2&"
import script from "./SupplierAdInfo.vue?vue&type=script&lang=js&"
export * from "./SupplierAdInfo.vue?vue&type=script&lang=js&"
import style0 from "./SupplierAdInfo.vue?vue&type=style&index=0&id=019d0ca2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports